import type { SVGProps } from 'react';

const PaymentPayPal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="24"
    fill="none"
    data-name="PayPal"
    viewBox="0 0 34 24"
    {...props}
  >
    <rect width={33} height={23} x={0.5} y={0.5} fill="#fff" stroke="#D9D9D9" rx={3.5} />
    <path
      fill="#003087"
      d="M13.5 7h2.6c1.4 0 2.3.9 2.1 2.2-.3 1.6-1.4 2.5-2.9 2.5h-.7l-.5 2.6h-1.6L13.5 7Zm1.6 3.4h.5c.6 0 1-.3 1.1-.9.1-.5-.2-.8-.8-.8h-.5l-.3 1.7Z"
    />
    <path
      fill="#009CDE"
      d="M16.2 8.2h2.6c1.4 0 2.3.9 2.1 2.2-.3 1.6-1.4 2.5-2.9 2.5h-.7l-.5 2.6h-1.6l1.5-7.3h-.5Zm1.6 3.4h.5c.6 0 1-.3 1.1-.9.1-.5-.2-.8-.8-.8h-.5l-.3 1.7Z"
    />
  </svg>
);
export default PaymentPayPal;
